export function getLessonAudioContent(rawLesson) {
  return rawLesson?.content || rawLesson || {};
}

export function buildFrontloadingTutorAudioId() {
  return 'frontloading.tutorScript';
}

export function buildTermAudioId(sequenceIndex, path) {
  return `termSequence[${sequenceIndex}].${path}`;
}

function pushEntry(entries, id, text) {
  const normalizedText = String(text || '').trim();
  if (!id || !normalizedText) return;
  entries.push({id, text: normalizedText});
}

export function buildLessonAudioManifest(rawLesson) {
  const content = getLessonAudioContent(rawLesson);
  const phases = content.phases || {};
  const frontloading = phases.frontloading || {};
  const termSequence = phases.termSequence || [];
  const entries = [];

  pushEntry(entries, buildFrontloadingTutorAudioId(), frontloading.tutorScript);

  termSequence.forEach((term, index) => {
    const sequenceIndex =
      typeof term?.termIndex === 'number' ? term.termIndex : index;
    const learningSteps = Array.isArray(term?.learning)
      ? term.learning
      : term?.learning
      ? [term.learning]
      : [];
    const workbook = term?.workbook || {};
    const workbookExercises = Array.isArray(workbook?.exercises)
      ? workbook.exercises
      : workbook?.exercise ||
        workbook?.tutorReadExercise ||
        workbook?.tutorPresentOptions ||
        workbook?.correctAnswer
      ? [workbook]
      : [];
    const knowledgeCheck = term?.knowledgeCheck || {};

    learningSteps.forEach((learningStep, learningIndex) => {
      pushEntry(
        entries,
        buildTermAudioId(
          sequenceIndex,
          `learning[${learningIndex}].tutorScript`,
        ),
        learningStep?.tutorScript,
      );
    });

    pushEntry(
      entries,
      buildTermAudioId(sequenceIndex, 'workbook.tutorOpenWorkbook'),
      workbook.tutorOpenWorkbook,
    );

    workbookExercises.forEach((exercise, exerciseIndex) => {
      pushEntry(
        entries,
        buildTermAudioId(
          sequenceIndex,
          `workbook.exercises[${exerciseIndex}].tutorReadExercise`,
        ),
        exercise?.tutorReadExercise,
      );
      pushEntry(
        entries,
        buildTermAudioId(
          sequenceIndex,
          `workbook.exercises[${exerciseIndex}].tutorPresentOptions`,
        ),
        exercise?.tutorPresentOptions,
      );
      pushEntry(
        entries,
        buildTermAudioId(
          sequenceIndex,
          `workbook.exercises[${exerciseIndex}].tutorTransition`,
        ),
        exercise?.tutorTransition,
      );

      (exercise?.optionFeedback || []).forEach((feedback, feedbackIndex) => {
        pushEntry(
          entries,
          buildTermAudioId(
            sequenceIndex,
            `workbook.exercises[${exerciseIndex}].optionFeedback[${feedbackIndex}]`,
          ),
          feedback,
        );
      });
    });

    pushEntry(
      entries,
      buildTermAudioId(sequenceIndex, 'workbook.tutorTransition'),
      workbook.tutorTransition,
    );

    pushEntry(
      entries,
      buildTermAudioId(sequenceIndex, 'knowledgeCheck.tutorTransition'),
      knowledgeCheck.tutorTransition,
    );
  });

  return entries;
}
